<section class="ai-narration">
  <p>{{ block.narration }}</p>

  <div class="ai-contact-list" *ngIf="block.contacts?.length">
    <article class="ai-contact" *ngFor="let contact of block.contacts">
      <span>{{ contact.name.charAt(0) }}</span>
      <div>
        <strong>{{ contact.name }}</strong>
        <small>{{ contact.email }}</small>
      </div>
    </article>
  </div>
</section>
